import { render, staticRenderFns } from "./Copywriting.vue?vue&type=template&id=b895fcc2&scoped=true"
import script from "./Copywriting.vue?vue&type=script&lang=js"
export * from "./Copywriting.vue?vue&type=script&lang=js"
import style0 from "./Copywriting.vue?vue&type=style&index=0&id=b895fcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b895fcc2",
  null
  
)

export default component.exports